import React from "react";
import { Header, Container } from "semantic-ui-react";

const NoDocs = () => {
  return (
    <Container text>
      <Header as="h2">No Documentation Available</Header>
      <p>
        Unfortunately, there is no documentation available for this section at
        the moment. Please check back later or contact support for assistance.
      </p>
    </Container>
  );
};

export default NoDocs;
